// extracted by mini-css-extract-plugin
module.exports = {"root":"expand_root__WzNM4","expanded":"expand_expanded__f2a6h"};